// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-waivers-workItems-work-item-list-module__contentWrapper--HYsdp {
  background-color: #071C31;
  padding: 0 10px;
}

.src-js-waivers-workItems-work-item-list-module__searchCriteria--PAhUN {
  background-color: #828E9A;
  margin: 15px 0;
}

.src-js-waivers-workItems-work-item-list-module__searchCriteriaTitle--z6jt7 {
  background-color: #C1C7CD;
  color: #071C35;
  font-weight: 500;
  padding: 15px;
}

.src-js-waivers-workItems-work-item-list-module__searchCriteriaContent--dGOHW {
  padding: 15px;
}

.src-js-waivers-workItems-work-item-list-module__searchCriteria--PAhUN input, select {
  background-color: #A8B0B8 !important;
  color: white !important;
  border: 1px solid white !important;
}

.src-js-waivers-workItems-work-item-list-module__waiverListAirlineSnoozeStatus--Uj8XO {
  position: absolute;
  top: 10px;
  right: 15px;
  z-index: 1000;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatus--G9bG0 {
  width: 18rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusButton--GKh9f {
  cursor: pointer;
  font-weight: 400;
  background-color: #C1C7CD;
  color: black;
  padding: 5px 12px;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusButton--GKh9f:hover {
  color: white;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusArrow--kvTGW {
  vertical-align: middle;
  float: right;
  margin-top: 5px;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusContent--TuVzE {
  background-color: #828E9A;
  max-height: 10rem;
  overflow: hidden;
  overflow-y: auto;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeRow--DAle5 {
  padding: 10px;
  display: flex;
  justify-content: space-between;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeAirline--kzvM8 {
  display: inline-block;
  font-weight: 400;
}

.src-js-waivers-workItems-work-item-list-module__airlineSnoozeCancel--WOgqR {
  display: inline-block;
  cursor: pointer;
  font-weight: 400;
  background-color: #FAA718;
  border-radius: 4px;
  padding: 5px 10px;
  margin-left: 20px;
}

`, "",{"version":3,"sources":["webpack://./src/js/waivers/workItems/work-item-list.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".contentWrapper {\n  background-color: #071C31;\n  padding: 0 10px;\n}\n\n.searchCriteria {\n  background-color: #828E9A;\n  margin: 15px 0;\n}\n\n.searchCriteriaTitle {\n  background-color: #C1C7CD;\n  color: #071C35;\n  font-weight: 500;\n  padding: 15px;\n}\n\n.searchCriteriaContent {\n  padding: 15px;\n}\n\n.searchCriteria input, select {\n  background-color: #A8B0B8 !important;\n  color: white !important;\n  border: 1px solid white !important;\n}\n\n.waiverListAirlineSnoozeStatus {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  z-index: 1000;\n}\n\n.airlineSnoozeStatus {\n  width: 18rem;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n}\n\n.airlineSnoozeStatusButton {\n  cursor: pointer;\n  font-weight: 400;\n  background-color: #C1C7CD;\n  color: black;\n  padding: 5px 12px;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.airlineSnoozeStatusButton:hover {\n  color: white;\n}\n\n.airlineSnoozeStatusArrow {\n  vertical-align: middle;\n  float: right;\n  margin-top: 5px;\n}\n\n.airlineSnoozeStatusContent {\n  background-color: #828E9A;\n  max-height: 10rem;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.airlineSnoozeRow {\n  padding: 10px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.airlineSnoozeAirline {\n  display: inline-block;\n  font-weight: 400;\n}\n\n.airlineSnoozeCancel {\n  display: inline-block;\n  cursor: pointer;\n  font-weight: 400;\n  background-color: #FAA718;\n  border-radius: 4px;\n  padding: 5px 10px;\n  margin-left: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentWrapper": `src-js-waivers-workItems-work-item-list-module__contentWrapper--HYsdp`,
	"searchCriteria": `src-js-waivers-workItems-work-item-list-module__searchCriteria--PAhUN`,
	"searchCriteriaTitle": `src-js-waivers-workItems-work-item-list-module__searchCriteriaTitle--z6jt7`,
	"searchCriteriaContent": `src-js-waivers-workItems-work-item-list-module__searchCriteriaContent--dGOHW`,
	"waiverListAirlineSnoozeStatus": `src-js-waivers-workItems-work-item-list-module__waiverListAirlineSnoozeStatus--Uj8XO`,
	"airlineSnoozeStatus": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatus--G9bG0`,
	"airlineSnoozeStatusButton": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusButton--GKh9f`,
	"airlineSnoozeStatusArrow": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusArrow--kvTGW`,
	"airlineSnoozeStatusContent": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeStatusContent--TuVzE`,
	"airlineSnoozeRow": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeRow--DAle5`,
	"airlineSnoozeAirline": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeAirline--kzvM8`,
	"airlineSnoozeCancel": `src-js-waivers-workItems-work-item-list-module__airlineSnoozeCancel--WOgqR`
};
export default ___CSS_LOADER_EXPORT___;
